import { render, staticRenderFns } from "./dtlSysDoc.vue?vue&type=template&id=4601e3d4&scoped=true&"
import script from "./dtlSysDoc.vue?vue&type=script&lang=js&"
export * from "./dtlSysDoc.vue?vue&type=script&lang=js&"
import style0 from "./dtlSysDoc.vue?vue&type=style&index=0&id=4601e3d4&prod&lang=css&"
import style1 from "./dtlSysDoc.vue?vue&type=style&index=1&id=4601e3d4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4601e3d4",
  null
  
)

export default component.exports